import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProducerList from './ProducerList';
import ProducerForm from './ProducerForm';

const ProducerRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ProducerList />} />
      <Route path="/create" element={<ProducerForm />} />
      <Route path="/edit/:producerId" element={<ProducerForm />} />
      <Route path="*" element={<Navigate to="/admin/producers" replace />} />
    </Routes>
  );
};

export default ProducerRoutes;